import Vue from 'vue';
import { firestoreAction } from 'vuexfire';

import { db } from '../../firebase';
import PluggableModule from '../pluggable';

const relatedConcepts = new PluggableModule('relatedConcept');

const ucName = 'TOPICS_CONCEPT';
const GET_INIT = `${ucName}_GET_INIT`;
const GET_ERROR = `${ucName}_GET_ERROR`;
const GET_DONE = `${ucName}_GET_DONE`;
const SET_TYPE_KEY = `${ucName}_SET_TYPE_KEY`;
const CLEAR_TYPE = `${ucName}_CLEAR_TYPE`;
const SET_USER_ID = `${ucName}_SET_USER_ID`;

relatedConcepts.addMutationTypes([
  GET_INIT,
  GET_ERROR,
  GET_DONE,
  SET_TYPE_KEY,
  CLEAR_TYPE,
  SET_USER_ID
]);

relatedConcepts.extend({
  namespaced: true,
  state: {
    loading: false,
    loadError: null,
    userId: '',
    challenge: null,
    concepts: {},
    conceptAttempts: {}
  },
  mutations: {
    [GET_INIT](state) {
      state.loading = true;
      state.loadError = null;
    },
    [GET_DONE](state) {
      state.loading = false;
    },
    [GET_ERROR](state, error) {
      state.loadError = error;
      state.loading = false;
    },
    [SET_TYPE_KEY](state, { type, key }) {
      Vue.set(state[type], key, {});
    },
    [CLEAR_TYPE](state, type) {
      state[type] = {};
    },
    [SET_USER_ID](state, userId) {
      state.userId = userId;
    }
  },
  actions: {
    async loadChallengeId({ commit, dispatch }, { challengeId, userId }) {
      commit(relatedConcepts.con.LOADING_INIT, null, { root: true });
      commit(SET_USER_ID, userId);
      commit(GET_INIT);
      try {
        await dispatch('bindTypeAndKey', {
          key: 'challenge',
          ref: db
            .collection('challenges')
            .doc(challengeId)
            .collection('data')
            .doc('details'),
          maxRefDepth: 2
        });
        await dispatch('loadConcepts');
        await dispatch('loadConceptAttempts');
        commit(GET_DONE);
      } catch (error) {
        commit(GET_ERROR, error);
      }
      commit(relatedConcepts.con.LOADING_DONE, null, { root: true });
    },
    async loadConcepts({ dispatch, state }) {
      await dispatch('unbindTypeOrKey', { type: 'concepts' });
      await Promise.all(
        state.challenge.relatedTopics.map(
          async topic =>
            await dispatch('bindTypeAndKey', {
              type: 'concepts',
              key: topic.id,
              ref: db
                .collection('publishedConcepts')
                .where('topicId', '==', db.collection('topics').doc(topic.id))
                .orderBy('serialNumber')
            })
        )
      );
    },
    async loadConceptAttempts({ dispatch, state }) {
      await dispatch('unbindTypeOrKey', { type: 'conceptAttempts' });
      await Promise.all(
        Object.values(state.concepts).map(
          async concepts =>
            await Promise.all(
              concepts.map(
                async concept =>
                  await dispatch('bindTypeAndKey', {
                    type: 'conceptAttempts',
                    key: `${concept.id}_${state.userId}`
                  })
              )
            )
        )
      );
    },
    async clearChallengeId({ dispatch }) {
      await dispatch('unbindTypeOrKey', { key: 'challenge' });
      await dispatch('unbindTypeOrKey', { type: 'concepts' });
      await dispatch('unbindTypeOrKey', { type: 'conceptAttempts' });
    },
    bindTypeAndKey: firestoreAction(
      async (
        { bindFirestoreRef, commit },
        { type, key, ref = db.collection(type).doc(key), maxRefDepth = 1 }
      ) => {
        if (type) commit(SET_TYPE_KEY, { type, key });
        await bindFirestoreRef(`${type ? `${type}.` : ''}${key}`, ref, {
          maxRefDepth
        });
      }
    ),
    unbindTypeOrKey: firestoreAction(
      async ({ unbindFirestoreRef, state, commit }, { type, key }) => {
        if (type && key) {
          await unbindFirestoreRef(`${type}.${key}`);
        } else if (type) {
          await Promise.all(
            Object.keys(state[type]).map(
              async member => await unbindFirestoreRef(`${type}.${member}`)
            )
          );
          commit(CLEAR_TYPE, type);
        } else if (key) {
          await unbindFirestoreRef(key);
        }
      }
    )
  }
});

export default relatedConcepts;
